import { bwColor } from '@fattureincloud/fic-design-system/dist/styles/types';

export const black: bwColor = {
  8: '#33333314',
  16: '#33333328',
  48: '#3333337A',
  80: '#333333CC',
  100: '#333333'
};
